<script>
    import * as d3 from "d3";
    import {onMount} from 'svelte';
    export let data,
               annotation_lines,
               annotation_ranges;

    let container;
    let height = 180;

    onMount(() => {

      function draw() {
        let containerSelect = d3.select(container);
        containerSelect.html("");

        let svg = containerSelect.append("svg")
          .attr("class", "line-chart")
          .attr("height", height);

        const margin = {top: 30, right: 10, bottom: 30, left: 30},
          width = svg.node().getBoundingClientRect().width, 
          widthInner = width - margin.left - margin.right,
          heightInner = height - margin.top - margin.bottom;

        svg.attr("width", width)

        var x = d3.scaleTime()
          .domain(d3.extent(data, function(d) { return d.date; }))
          .range([ 0, widthInner ]);

        var y = d3.scaleLinear()
          .domain([0, d3.max(data, function(d) { return +d.value; })])
          .range([ heightInner, 0 ]);

        let g = svg
          .append("g")
          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        // Annotation range
        g.selectAll(".annotation-range")
          .data(annotation_ranges)
          .enter()
          .append("rect")
          .attr("class", "annotation-range")
          .attr("x", d => x(d.start_date))
          .attr("width", d => x(d.end_date) - x(d.start_date))
          .attr("y", 0)
          .attr("height", heightInner)
          .attr("fill", "#eee");

        // Annotation line label
        containerSelect.selectAll(".annotation-range-text")
          .data(annotation_ranges)
          .enter()
          .append("div")
          .attr("class", "annotation-range-text")
          // .style('top', 90 + "px")
          .style('top', "-4px")
          .style('left', d => x(d.start_date) + margin.left + "px")
          .style('width', "150px")
          // .style('width', d => x(d.end_date) - x(d.start_date) + "px")
          .text(d => d.label);

        g.append("path")
          .datum(data)
          .attr("class","area")
          .attr("fill", "#cce5df")
          .attr("stroke", "#none")
          .attr("d", d3.area()
            .x(function(d) { return x(d.date) })
            .y0(y(0))
            .y1(function(d) { return y(d.value) })
            .curve(d3.curveCardinal)
          );

        // Add y axis
        const yAxis = d3.axisLeft().scale(y)
          .ticks(4)
          .tickFormat(d3.format(',.0%'))
          .tickSize(-innerWidth);

        g.append("g")
          .attr("class", "axis y")
          .call(yAxis);

        g.append("path")
          .datum(data)
          .attr("class","line")
          .attr("fill", "none")
          .attr("stroke", "steelblue")
          .attr("d", d3.line()
            .x(function(d) { return x(d.date) })
            .y(function(d) { return y(d.value) })
            .curve(d3.curveCardinal)
          );

        // Hide area below 0
        // g.append("rect")
        //   .attr("x", 0)
        //   .attr("width", widthInner)
        //   .attr("y", y(0) + 1)
        //   .attr("height", margin.bottom)
        //   .attr("fill", "#fff");

        // Add x axis
        const xAxis = d3.axisBottom().scale(x)
          .ticks(width > 400 ? 12 : 4)
          .tickFormat(d3.timeFormat('%b'));

        g.append("g")
          .attr("transform", "translate(0," + heightInner + ")")
          .attr("class", "axis x")
          .call(xAxis);

        // Add x axis
        const xAxisYears = d3.axisBottom().scale(x)
        .tickFormat(function(date, i){
          if (date.getMonth() == 0) {
            return d3.timeFormat('%Y')(date);
          } else if (i == 0) {
            return d3.timeFormat('%Y')(date);
          } else {
            return '';
          }
        });

        g.append("g")
          .attr("transform", "translate(0," + (heightInner + 12) + ")")
          .attr("class", "axis x years")
          .call(xAxisYears);

        // Annotation lines
        g.selectAll(".annotation-line")
          .data(annotation_lines)
          .enter()
          .append("line")
          .attr("class", "annotation-line")
          .attr("x1", d => x(d.date))
          .attr("x2", d => x(d.date))
          .attr("y1", 0)
          .attr("y2", heightInner)
          .attr("stroke-width", 1)
          .attr("stroke", "black");

        // Annotation line label
        containerSelect.selectAll(".annotation-line-text")
          .data(annotation_lines)
          .enter()
          .append("div")
          .attr("class", "annotation-line-text")
          .style('top', margin.top + "px")
          .style('left', d => x(d.date) + 4 + margin.left + "px")
          .text(d => d.label);
      }

      draw();
      window.addEventListener('resize', draw);
    })
</script>

<div bind:this={container} style="position:relative;" aria-hidden="true"></div>